import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { startVersionControl } from './shared/utils/versionControl';

Object.assign(globalThis, {
  __SODOR_DEBUG_FLAGS__: {
    dev: import.meta.env.DEV,
    VITE_DEBUG_LOGS_ENABLED:
      window.__BARNAMEGRAM_CONFIG__?.VITE_DEBUG_LOGS_ENABLED ?? import.meta.env.VITE_DEBUG_LOGS_ENABLED,
    VITE_DEBUG_BUGS_ENABLED: import.meta.env.VITE_DEBUG_BUGS_ENABLED,
    VITE_DEBUG_FEATURE_REQUESTS_ENABLED: import.meta.env.VITE_DEBUG_FEATURE_REQUESTS_ENABLED,
  },
});

// Verify root element exists
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found!');
}

console.log('🚀 Starting React App...');
startVersionControl();

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
